import React from 'react';
import ProductCard from './ProductCard';
import { Link } from 'react-router-dom';

const ProductShowcase = ({ title, products, subtitle, loading, badge, showSeeMore = true, showExclusiveBadge = true, seeMoreLink }) => {
  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between mb-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold">{title}</h2>
            {subtitle && (
              <p className="text-gray-600 mt-2 text-sm">{subtitle}</p>
            )}
            <div className="w-16 h-0.5 bg-gold mx-auto mt-2"></div>
          </div>
          {!loading && showSeeMore && (
            <Link to={seeMoreLink || '/shop-all'} className="text-sm font-medium text-gold hover:brightness-90 transition-colors">
              See More →
            </Link>
          )}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="bg-gray-200 aspect-[3/4] rounded-xl mb-4"></div>
                <div className="bg-gray-200 h-4 rounded w-3/4 mb-2"></div>
                <div className="bg-gray-200 h-4 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 items-stretch">
            {products.map((product, index) => (
              <ProductCard
                key={product.id || index}
                product={product}
                badge={badge}
                isNew={product.is_new}
                isExclusive={showExclusiveBadge ? undefined : false}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductShowcase;